const RETRY = 10;
const DELAY = 1_000;

export abstract class BaseSubgraphService {
  protected constructor() {}

  protected retry() {
    return { count: RETRY, delay: DELAY };
  }
}
